import React, { useState, useEffect } from 'react';
import userClienteService from '../../../services/userClienteService';
import clienteService from '../../../services/clienteService';

const GerenciarClientesUsuario = ({ userId, onClose, onSave }) => {
    const [clientes, setClientes] = useState([]);
    const [clientesSelecionados, setClientesSelecionados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingClientes, setLoadingClientes] = useState(true);
    const [todosClientes, setTodosClientes] = useState([]);

    useEffect(() => {
        carregarDados();
    }, [userId]);

    const carregarDados = async () => {
        try {
            setLoadingClientes(true);

            // Carregar clientes que o usuário já tem acesso
            const clientesDoUsuario = await userClienteService.listarClientesDoUsuario(userId);
            setClientes(clientesDoUsuario);
            setClientesSelecionados(clientesDoUsuario.map(c => c.id));

            // Carregar todos os clientes disponíveis
            const todosOsClientes = await clienteService.listarTodos();
            setTodosClientes(todosOsClientes);

        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            alert('Erro ao carregar dados dos clientes');
        } finally {
            setLoadingClientes(false);
        }
    };

    const handleToggleCliente = (clienteId) => {
        setClientesSelecionados(prev => {
            if (prev.includes(clienteId)) {
                return prev.filter(id => id !== clienteId);
            } else {
                return [...prev, clienteId];
            }
        });
    };

    const handleSelecionarTodos = () => {
        setClientesSelecionados(todosClientes.map(c => c.id));
    };

    const handleDeselecionarTodos = () => {
        setClientesSelecionados([]);
    };

    const handleSalvar = async () => {
        try {
            setLoading(true);

            // Substituir todos os clientes (remove antigos, adiciona novos)
            await userClienteService.substituirClientes(userId, clientesSelecionados);

            alert('Clientes atualizados com sucesso!');
            
            if (onSave) {
                onSave();
            }

            if (onClose) {
                onClose();
            }

        } catch (error) {
            console.error('Erro ao salvar clientes:', error);
            alert('Erro ao salvar clientes: ' + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    if (loadingClientes) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 max-w-2xl w-full">
                    <div className="text-center">Carregando...</div>
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[80vh] flex flex-col">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">Gerenciar Clientes do Usuário</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>

                {/* Info */}
                <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
                    <p className="text-sm text-blue-800">
                        Selecione os clientes que este usuário pode acessar. 
                        O usuário verá apenas obras e pedidos de compra relacionados aos clientes selecionados.
                    </p>
                </div>

                {/* Botões de ação */}
                <div className="flex gap-2 mb-4">
                    <button
                        onClick={handleSelecionarTodos}
                        className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                        Selecionar Todos
                    </button>
                    <button
                        onClick={handleDeselecionarTodos}
                        className="px-3 py-1 text-sm bg-gray-500 text-white rounded hover:bg-gray-600"
                    >
                        Desmarcar Todos
                    </button>
                </div>

                {/* Lista de clientes */}
                <div className="flex-1 overflow-y-auto border rounded p-4 mb-4">
                    {todosClientes.length === 0 ? (
                        <div className="text-center text-gray-500 py-8">
                            Nenhum cliente cadastrado
                        </div>
                    ) : (
                        <div className="space-y-2">
                            {todosClientes.map(cliente => (
                                <label
                                    key={cliente.id}
                                    className="flex items-start p-3 border rounded hover:bg-gray-50 cursor-pointer"
                                >
                                    <input
                                        type="checkbox"
                                        checked={clientesSelecionados.includes(cliente.id)}
                                        onChange={() => handleToggleCliente(cliente.id)}
                                        className="mt-1 mr-3 h-4 w-4"
                                    />
                                    <div className="flex-1">
                                        <div className="font-semibold">{cliente.nome}</div>
                                        {cliente.cnpj && (
                                            <div className="text-sm text-gray-600">
                                                CNPJ: {cliente.cnpj}
                                            </div>
                                        )}
                                        {cliente.obras && cliente.obras.length > 0 && (
                                            <div className="text-xs text-gray-500 mt-1">
                                                {cliente.obras.length} obra(s) vinculada(s)
                                            </div>
                                        )}
                                    </div>
                                </label>
                            ))}
                        </div>
                    )}
                </div>

                {/* Footer com contador */}
                <div className="mb-4 text-sm text-gray-600">
                    {clientesSelecionados.length} de {todosClientes.length} cliente(s) selecionado(s)
                </div>

                {/* Botões de ação */}
                <div className="flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSalvar}
                        disabled={loading}
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
                    >
                        {loading ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GerenciarClientesUsuario;
